export default __webpack_public_path__ + "static/recognition-program-cbc834b5948792c1317affaf02a2c9fb.png";